// BASIC:
import React from "react"
import "./style.sass"

// UTILITIES:
import { Col } from "react-bootstrap"
import { v4 as uuid } from "uuid"

// COMPONENTS:

// COMPONENT=>

const AsideViewer = ({ heading, list }) => {
  return (
    <aside className="aside-viewer">
      <div className="aside-wrapper">
        <div>
          <div className="heading">
            <h1 className="aside-heading">{heading}</h1>
          </div>
          {/* list */}
          {list && (
            <section className="aside-list">
              <ul>
                {list.map(li => (
                  <li key={uuid()}>{li}</li>
                ))}
              </ul>
            </section>
          )}
          {/* footer */}
          <section className="aside-footer">
            <p>
              Follow Me on{" "}
              <b>
                <a href="http://twitter.com/salihcodev" target="_blank" rel="noopener noreferrer">
                  Twitter
                </a>
              </b>{" "}
              or{" "}
              <b>
                <a href="http://github.com/salihcodev" target="_blank" rel="noopener noreferrer">
                  Github
                </a>
              </b>
            </p>
          </section>
        </div>
      </div>
    </aside>
  )
}

export default AsideViewer
